import React from "react";
import { Outlet } from "react-router-dom";
import TopNavbar from "./TopNavbar";
import "../css/adminLayout.css";

export default function AdminLayout() {
  return <div className="dashboard-glass admin-theme admin-layout">
    <TopNavbar />
    <div className="admin-content"><Outlet /></div>
  </div>;
}
